import { CacheClientService, CacheLocation } from "@rightship-tech/common-ui/services/basic/client-caching.service";
import { autoinject } from "aurelia-dependency-injection";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import {Urls} from '../../constants/import-entities/import-entities.constants';
import { ImportEntityMetaDataModel } from "../../models/import-entities/import-entities.models";

@autoinject
export class ImportEntitiesClientService {

    private cacheKeyImport = "GetImportEntityModels";

    constructor(private requestClient: RequestClientService, private clientCache: CacheClientService) {
    }

    public getImportEntityModels(): Promise<ImportEntityMetaDataModel[]> {

        const promise = new Promise<ImportEntityMetaDataModel[]>((resolve, reject) => {
            this.clientCache.get<ImportEntityMetaDataModel[]>(this.cacheKeyImport, CacheLocation.SessionStorage).then(x => {
                if (x) {
                    resolve(x);
                } else {
                    this.requestClient.get<any>(Urls.GetImportEntities, null)
                        .then((result: any) => {
                            this.clientCache.put(this.cacheKeyImport, result, CacheLocation.SessionStorage);
                            resolve(result);
                        }, (error) => {
                            reject(error);
                        });
                }

            });
        });
        return promise;
    }

    public clearCache() {
        return new Promise((resolve, reject) => {
            this.clientCache.remove(this.cacheKeyImport, CacheLocation.SessionStorage).then(resolve).catch(reject);
        });
    }
}
